
<script type="text/babel">
// import langSets from './dataMap/langSets'
import dateFunc from '@/utils/dateFunc'
import moment from 'moment'
import EventCard from '@/components/EventCard.vue'
import fcheader from '@/components/header'
import calendarSelect from '@/components/CalendarSelect'
import { formatDate, DateUtil } from '@/utils/date.js'
import $ from 'jquery'
import { mapState } from 'vuex'
import apiConfig from '../../config/api.config.js'
import dialog from '@/components/Dialog'
export default {
  props: {
    events: { // events will be displayed on calendar
      type: Array,
      default: () => []
    },
    shiftInfoList: {
      type: Array,
      default: () => []
    },
    locale: {
      type: String,
      default: 'en'
    },
    firstDay: {
      type: Number | String,
      validator (val) {
        let res = parseInt(val)
        return res >= 0 && res <= 6
      },
      default: 0
    },
    isCreateNewEvent: {
      type: Boolean,
      default: true
    },
    driverName: '',
    uid: {
      type: String,
      default: ''
    }
  },
  created: function () {
    this.driverNameTitle = this.driverName + '(スケジュール)'
  },
  components: {
    // dialog 弹出框组件
    'v-dialog': dialog,
    'event-card': EventCard,
    'fc-header': fcheader,
    calendarSelect
  },
  mounted () {
    this.emitChangeMonth(this.currentMonth)
  },
  data () {
    return {
      // message提示弹出框配置信息
      showDialog: false,
      dialogOption: {
        showNo: false,
        text: '',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      currentMonth: moment().startOf('month'),
      isLismit: true,
      eventLimit: 4,
      showMore: false,
      morePos: {
        top: 0,
        left: 0
      },
      selectDay: {},
      weeks: ['日', '月', '火', '水', '木', '金', '土'],
      isCalendar: false,
      shiftMovementStatus: [
        '業務予定',
        '業務中',
        '業務終了',
        '業務未定',
        '強制終了'
      ],
      driverNameTitle: ''
    }
  },
  computed: {
    currentDates () {
      return this.getCalendar()
    },
    ...mapState({
      // date: state => (state.yearAndMonth).substring(2)
      scheduleDate: state => state.yearAndMonth
    })
  },
  methods: {
    emitChangeMonth (firstDayOfMonth) {
      this.currentMonth = firstDayOfMonth

      let start = dateFunc.getMonthViewStartDate(firstDayOfMonth, this.firstDay)
      let end = dateFunc.getMonthViewEndDate(firstDayOfMonth, this.firstDay)

      this.$emit('changeMonth', start, end, firstDayOfMonth)
    },
    moreTitle (date) {
      if (!date) return ''
      return moment(date).format('ll')
    },
    getCalendar () {
      // calculate 2d-array of each month
      let monthViewStartDate = dateFunc.getMonthViewStartDate(this.currentMonth, this.firstDay)
      let calendar = []

      for (let perWeek = 0; perWeek < 6; perWeek++) {
        let week = []

        for (let perDay = 0; perDay < 7; perDay++) {
          week.push({
            monthDay: monthViewStartDate.date(),
            isToday: monthViewStartDate.isSame(moment(), 'day'),
            isCurMonth: monthViewStartDate.isSame(this.currentMonth, 'month'),
            weekDay: perDay,
            date: moment(monthViewStartDate),
            events: this.slotEvents(monthViewStartDate)
          })
          monthViewStartDate.add(1, 'day')
        }
        calendar.push(week)
      }
      return calendar
    },
    slotEvents (date) {
      // find all events start from this date
      // let cellIndexArr = []
      let thisDayEvents = this.events.filter(day => {
        let st = moment(day.start)
        let ed = moment(day.end ? day.end : st)

        return date.isBetween(st, ed, null, '[]')
      })

      // sort by duration
      thisDayEvents.sort((a, b) => {
        if (!a.cellIndex) return 1
        if (!b.cellIndex) return -1
        return a.cellIndex - b.cellIndex
      })

      // mark cellIndex and place holder
      for (let i = 0; i < thisDayEvents.length; i++) {
        thisDayEvents[i].cellIndex = thisDayEvents[i].cellIndex || (i + 1)
        thisDayEvents[i].isShow = true
        if (thisDayEvents[i].cellIndex === i + 1 || i > 2) continue
        thisDayEvents.splice(i, 0, {
          title: 'holder',
          cellIndex: i + 1,
          start: date.format(),
          end: date.format(),
          isShow: false
        })
      }

      return thisDayEvents
    },
    selectThisDay (day, jsEvent) {
      this.selectDay = day
      this.showMore = true
      this.morePos = this.computePos(event.target)
      this.morePos.top -= 100
      let events = day.events.filter(item => {
        return item.isShow === true
      })
      this.$emit('moreClick', day.date, events, jsEvent)
    },
    computePos (target) {
      let eventRect = target.getBoundingClientRect()
      let pageRect = this.$refs.dates.getBoundingClientRect()
      return {
        left: eventRect.left - pageRect.left,
        top: eventRect.top + eventRect.height - pageRect.top
      }
    },
    dayClick (day, jsEvent) {
      this.$emit('dayClick', day, jsEvent)
    },
    eventClick (event, jsEvent) {
      if (!event.isShow) return

      jsEvent.stopPropagation()
      let pos = this.computePos(jsEvent.target)
      this.$emit('eventClick', event, jsEvent, pos)
    },
    showList () {
      this.isCalendar = false
    },
    showCalendar () {
      this.isCalendar = true
    },
    chooseColor (shiftInfo) {
      if (shiftInfo.businessStatus === 2) {
        return 'bgc4'
      } else if (shiftInfo.businessStatus === 3) {
        return 'bgc10'
      } else {
        // let count = shiftInfo.shiftReservationInfos.length
        // 「運行未定」の便は「未公開」状態の場合
        if ((shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 0)) {
          return 'bgc5'
        } else if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 1) {
          return 'bgc1'
        }
      }
    },
    chooseFontAndTrborder (shiftInfo) {
      if (shiftInfo.businessStatus === 2) {
        return 'F2-R-19 trborder3'
      } else if (shiftInfo.businessStatus === 3) {
        return 'F3-R-19 trborder4'
      } else {
        // let count = shiftInfo.shiftReservationInfos.length
        // 「運行未定」の便は「未公開」状態の場合
        // 运行未定
        if ((shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 0)) {
          return 'F3-R-19 trborder1'
        } else if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 1) {
          return 'F2-R-19 trborder2'
        }
      }
    },
    chooseFontAndTrborder2 (shiftInfo) {
      if (shiftInfo.businessStatus === 2) {
        return 'F2-R-16 trborder3'
      } else if (shiftInfo.businessStatus === 3) {
        return 'F3-R-16 trborder4'
      } else {
        // let count = shiftInfo.shiftReservationInfos.length
        // 「運行未定」の便は「未公開」状態の場合
        // 运行未定
        if ((shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 0)) {
          return 'F3-R-16 trborder1'
        } else if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 1) {
          return 'F2-R-16 trborder2'
        }
      }
    },
    chooseFontAndTrborder3 (shiftInfo) {
      if (shiftInfo.businessStatus === 2) {
        return 'F2-R-20 trborder3'
      } else if (shiftInfo.businessStatus === 3) {
        return 'F3-R-20 trborder4'
      } else {
        // let count = shiftInfo.shiftReservationInfos.length
        // 「運行未定」の便は「未公開」状態の場合
        // 运行未定
        if ((shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 0)) {
          return 'F3-R-20 trborder1'
        } else if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 1) {
          return 'F2-R-20 trborder2'
        }
      }
    },
    goDetail (shiftInfo) {
      this.$router.push({name: 'MovementShiftDetail', query: {shiftId: shiftInfo.shiftId, from: 'OneDriverSchedule'}})
    },
    goback () {
      this.$router.push({name: 'DriverList'})
    },
    // “运行未定、运行予定”状态判断
    checkShiftMovementStatus (shiftInfo) {
      let movementStatus = ''
      // 「運行未定」の便は「未公開」状態の場合
      if ((shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 0)) {
        movementStatus = this.shiftMovementStatus[3]
      } else if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 1) {
        movementStatus = this.shiftMovementStatus[0]
      } else if (shiftInfo.coercionStopFlag === 1) {
        movementStatus = this.shiftMovementStatus[4]
      } else {
        movementStatus = this.shiftMovementStatus[shiftInfo.businessStatus - 1]
      }
      return movementStatus
    },
    driverOneExcelReport () {
      this.showMessage('データをダウンロードします。<br/>よろしいですか？', true, '実行', 'キャンセル')

      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        this.showDialog = false
        this.downLoadDriverOneExcelReport()
      })
        .catch(() => {
          this.showDialog = false
        })
    },
    downLoadDriverOneExcelReport () {
      this.$axios.get('driver/queryDriverOneExcelReportSize', {params: {date: this.scheduleDate, uid: this.uid}})
        .then(response => {
          let hasDataFlag = response.data.hasDataFlag
          if (hasDataFlag) {
            let baseUrl = apiConfig.baseUrl
            var elemIF = document.createElement('iframe')
            elemIF.src = baseUrl + 'driver/driverOneExcelReport?date=' + this.scheduleDate + '&uid=' + this.uid
            elemIF.style.display = 'none'
            this.$refs.OneDriverScheduleComponent.appendChild(elemIF)
          } else {
            this.showMessage('出力データがありません。')
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    driverOneRecordReport () {
      this.$refs.calendarSelectWindow.selectYear = new Date().getFullYear()
      this.$refs.calendarSelectWindow.selectMonth = new Date().getMonth() + 1
      this.$refs.calendarSelectWindow.selectDay = new Date().getDate()
      $('#modal-container-calendarSelect').modal('show')
    },
    driverMovementRecordReport (selectedDate) {
      // 将日历组件选择的时间yyyy年MM月dd日转化为日期Date格式
      let selectDate = DateUtil.calendarToDate(selectedDate)
      // 将date格式转化为yyyyMMdd格式
      let forDate = formatDate(selectDate, 'yyyyMMdd')
      
      this.showMessage('データをダウンロードします。<br/>よろしいですか？', true, '実行', 'キャンセル')

      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        this.showDialog = false
        this.downLoaddriverMovementRecordReport(forDate)
      })
        .catch(() => {
          this.showDialog = false
        })
    },

    downLoaddriverMovementRecordReport(forDate){
      this.$axios.get('driver/queryDriverMovementInfoSize', {params: {moveShiftTime: forDate, driverUid: this.uid}})
        .then(response => {
          let hasDataFlag = response.data.hasDataFlag
          if (hasDataFlag) {
            let baseUrl = apiConfig.baseUrl
            var elemIF = document.createElement('iframe')
            elemIF.src = baseUrl + 'driver/exportDriverMovementInfoExcel?moveShiftTime=' + forDate + '&driverUid=' + this.uid
            elemIF.style.display = 'none'
            this.$refs.OneDriverScheduleComponent.appendChild(elemIF)
          } else {
            this.showMessage('出力データがありません。')
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // message dialog
    showMessage (title, yesNoFlag, yesText, noText) {
      this.dialogOption.text = title
      this.dialogOption.showNo = yesNoFlag
      this.dialogOption.confirmButtonText = yesText
      this.dialogOption.cancelButtonText = noText
      this.showDialog = true
      this.$refs.dialog
        .confirm()
        .then(() => {
          this.showDialog = false
        })
        .catch(() => {
          this.showDialog = false
        })
    }
  },
  filters: {
    localeWeekDay (weekday, firstDay, locale) {
      firstDay = parseInt(firstDay)
      const localMoment = moment().locale(locale)
      return localMoment.localeData().weekdaysShort()[(weekday + firstDay) % 7]
    }
  }
}

</script>

<template>
  <div class="comp-full-calendar" ref="OneDriverScheduleComponent">
    <!-- header pick month -->
    <div class="row clearfix" style="flex:0 0 40px;position: relative;">
      <div style="position: absolute;width: 100%">
        <div style="width:500px;margin:0 auto" class="member-name" :title="driverNameTitle">
          <strong class="name-strong F3-M-27">{{driverName}} (スケジュール)</strong>
        </div>
      </div>
      <div class="col-md-2 column headerleft F1-R-19" style="vertical-align: bottom;margin-left:20px">
        <input type="button" value="ドライバーリストに戻る" @click="goback()" />
      </div>
      <div class="col-md-2 column headerbtndiv" style="width:360px;margin-right:10px">
        <button class="common-btn user-btn F2-M-19 detailed-button"  style="border:0px;" @click="driverOneRecordReport()"> 運行記録出力</button>
        <button class="common-btn user-btn F2-M-19 detailed-button" style="border:0px" @click="driverOneExcelReport"> シフト出力</button>
      </div>
    </div>
    <hr class="hrheader">
    <!-- br下面的日历控件 -->
    <fc-header :current-month="currentMonth" :first-day="firstDay" :locale="locale" @change="emitChangeMonth" style="margin-top:-10px">
      <div slot="header-left">
        <slot name="fc-header-left">
          <div class="clearfix" style="padding-left:15px;">
            <div class="left-btn col-md-6 column" @click="showList" style="border-bottom-left-radius: 10px;border-top-left-radius: 10px;"
              :style="{color:isCalendar?'rgb(204,204,204)':''}">
              <img v-show="!isCalendar" src="@/assets/button/list_button1.png" class="left-img" />
              <img v-show="isCalendar" src="@/assets/button/list_button2.png" class="left-img" />
              <span :class="isCalendar?'F9-M-19':'F1-M-19'">リスト</span>
            </div>
            <div class="left-btn col-md-6 column" @click="showCalendar" style="border-bottom-right-radius: 10px;border-top-right-radius: 10px;"
              :style="{color:isCalendar?'':'rgb(204,204,204)'}">
              <img v-show="isCalendar" src="@/assets/button/calender_button1.png" class="left-img" />
              <img v-show="!isCalendar" src="@/assets/button/calender_button2.png" class="left-img" />
              <span :class="isCalendar?'F1-M-19':'F9-M-19'">カレンダー</span>
            </div>
          </div>
        </slot>
      </div>
    </fc-header>

    <!--ShiftList-->
    <div class="col-md-12 column " style="display:flex;flex-direction: column" v-show="!isCalendar">
      <div class="table-container" style="margin-left:0px;margin-right:0px;height:65vh;">
        <div class=" table-header" style="padding-right:10px;">
          <table>
            <thead>
              <tr class="theader F2-R-15 bgc9">
                <!-- 運行日時、便ID、便名、>氏名、フリガナ、预约情况-->
                <td class="trborder shift-move-time htd">運行日時</td>
                <td class="trborder shift-id htd">便ID</td>
                <td class="trborder shift-name htd">便名</td>
                <td class="trborder shift-status htd"></td>
              </tr>
            </thead>
          </table>
        </div>
        <div class="table-body scrollbar">
          <table class="table">
            <tbody>
              <tr class="contenttr bgc5h" :class="chooseColor(shiftInfo)" v-for='shiftInfo in shiftInfoList' v-bind:key="shiftInfo.shiftId">
                <td class="bodytext shift-move-time" @click="goDetail(shiftInfo)" :class="chooseFontAndTrborder(shiftInfo)">
                  <div class="row clearfix">
                    <div v-if="shiftInfo.moveShiftTime!==null" class="col-md-6 column move-day">
                      {{shiftInfo.moveShiftTime}}
                    </div>
                    <div v-else class="col-md-6 column move-day">
                      未定
                    </div>
                    <div v-if="shiftInfo.startTime!==null" class="col-md-3 column move-start">
                      {{shiftInfo.startTime}}発
                    </div>
                    <div v-else class="col-md-3 column move-start">
                      未定
                    </div>
                    <div v-if="shiftInfo.arriveTime!==null" class="col-md-3 column move-arrive">
                      {{shiftInfo.arriveTime}}着
                    </div>
                    <div v-else class="col-md-3 column move-arrive">
                      未定
                    </div>
                  </div>
                </td>
                <!-- <td class="bodytext shift-id" @click="goDetail(shiftInfo)" :class="chooseFontAndTrborder2(shiftInfo)">{{shiftInfo.shiftId}}</td> -->
                <td class="bodytext shift-id" @click="goDetail(shiftInfo)" :class="chooseFontAndTrborder2(shiftInfo)" style="padding-top:0px;padding-bottom:0px"><div style="height: 54px;display: flex;align-items: center;">{{shiftInfo.shiftId}}</div></td>
                <td class="bodytext shift-name member-name" :title="shiftInfo.title" @click="goDetail(shiftInfo)" :class="chooseFontAndTrborder(shiftInfo)">{{shiftInfo.title}}</td>
                <td style="text-align:center;border-right:none" class="bodytext shift-status" @click="goDetail(shiftInfo)" :class="chooseFontAndTrborder3(shiftInfo)">
                  {{checkShiftMovementStatus(shiftInfo)}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- body display date day and events 日历 < カレンダー > -->
    <div class="full-calendar-body" v-show="isCalendar">
      <div class="weeks bgc8">
        <span class="week F3-R-19" v-for="dayIndex in 7" :key="dayIndex">{{ weeks[(dayIndex - 1)] }}</span>
      </div>

      <div class="dates" ref="dates">
        <div class="dates-bg">
          <div class="week-row" v-for="week in currentDates" :key="week.id">
            <div class="day-cell" v-for="(day,index) in week" :class="{'bgc12' : day.isToday,'F1-R-27' : day.isCurMonth,'F7-R-27' : !day.isCurMonth,'bgc8':index===0||index===week.length-1}"
              :key="day.id">
              <p class="day-number">{{ day.monthDay }}</p>
            </div>
          </div>
        </div>

        <div class="dates-events">
          <div class="events-week" v-for="week in currentDates" :key="week.id">
            <div class="events-day" v-for="day in week" track-by="$index" :key="day.id" :class="{'today' : day.isToday,
              'not-cur-month' : !day.isCurMonth}" @click.stop="dayClick(day.date, $event)">
              <!-- <p class="day-number">{{day.monthDay}}</p> -->
              <div class="event-box">
                <event-card :event="event" :date="day.date" :firstDay="firstDay" v-for="event in day.events" v-show="event.cellIndex <= eventLimit"
                  @click="eventClick" :key="event.id">
                  <template slot-scope="p">
                    <slot name="fc-event-card" :event="p.event"></slot>
                  </template>
                </event-card>
                <p v-if="day.events.length > eventLimit" class="more-link" @click.stop="selectThisDay(day, $event)">
                  + {{day.events[day.events.length -1].cellIndex - eventLimit}} more
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="more-events" v-show="showMore" :style="{left: morePos.left + 'px', top: morePos.top + 'px'}">
          <div class="more-header">
            <span class="title">{{ moreTitle(selectDay.date) }}</span>
            <span class="close" @click.stop="showMore = false">x</span>
          </div>
          <div class="more-body">
            <ul class="body-list">
              <li v-for="event in selectDay.events" :key="event.id" v-show="event.isShow" class="body-item" @click="eventClick(event, $event)">
                {{event.title}}
              </li>
            </ul>
          </div>
        </div>

        <slot name="body-card"></slot>

      </div>
    </div>
     <calendarSelect  @getSelectedDate="driverMovementRecordReport" ref="calendarSelectWindow"></calendarSelect>
    <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
  </div>
</template>

<style lang="scss" scoped>@import "../assets/css/C00.css";
.name-strong {
  font-size: 30px;
}
.hrheader {
  background-color: rgb(148, 148, 148);
  height: 1px;
  width: 500px;
}
.headerbtndiv {
  display: flex;
  flex-direction: row;
  float: right; // width: 420px;想要按钮固定式可以设置该div的宽度
}
.headerleft {
  width: 300px;
  background: url(../assets/button/back_button.png) no-repeat 10px center;
}
.headerleft input {
  float: left;
  border: none;
  background: none;
  line-height: 40px;
  width: 100%;
  text-align: left;
  // font-weight: bold;
  text-indent: 30px;
  // font-size: 20px;
}
.comp-full-calendar {
  // font-family: "elvetica neue", tahoma, "hiragino sans gb";
  padding-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  max-width: 100%; //min-width: 1000px;
  margin: 0 auto;
  ul {
    margin: 0;
    padding: 0;
  }
}

.left-btn {
  height: 50px;
  width: 45%;
  border-radius: 10px;
  background: linear-gradient(#DCDCDC, #ffffff);
  border: 0px;
  font-size: 20px;
  padding: 5px;
  text-align: left;
  padding-left: 10px;
}

.user-btn {
  float: right;
  margin-right: 5px;
  flex: 1;
  width: auto !important;
}
.full-calendar-body {
  margin-top: 8px;
  .weeks {
    display: flex;
    border-top: 1px solid #9D9D9D;
    border-bottom: 1px solid #9D9D9D;
    border-left: 1px solid #9D9D9D;
    background-color: #F0F0F0;
    .week {
      padding-top: 3px;
      flex: 1;
      text-align: center;
      border-right: 1px solid #9D9D9D;
      height: 3.5vh;
      font-size: 18px;
    }
  }
  .dates {
    position: relative;
    .week-row {
      // width: 100%;
      // position:absolute;
      border-left: 1px solid #9D9D9D;
      display: flex; // height: 108px;
      .day-cell {
        flex: 1; // min-height: 110px;
        padding: 4px;
        border-right: 1px solid #9D9D9D;
        border-bottom: 1px solid #9D9D9D;
        height: 10.7vh;
        .day-number {
          text-align: right;
          font-size: 25px;
        }
        @media screen and (max-device-width: 1480px) {
          .day-number {
            font-size: 20px;
          }
        }
        &.today {
          background-color: #DCDCDC;
        }
        &.not-cur-month {
          .day-number {
            color: #8E8E8E;
          }
        }
      }
    }
    .dates-events {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      .events-week {
        display: flex;
        .events-day {
          cursor: pointer;
          flex: 1;
          min-height: 80%;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 10.7vh;
          .day-number {
            text-align: right;
            opacity: 0;
          }
          &.not-cur-month {
            .day-number {
              color: rgba(0, 0, 0, .24);
            }
          }
          .event-box {
            padding-top: 5px;
            .event-item {
              cursor: pointer;
              font-size: 12px; //background-color:#C7E6FD;
              color: rgba(0, 0, 0, .87);
              padding: 0 0 0 4px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: left;
              margin-left: 10px;
              width: 75%;
              white-space: nowrap;
              &.is-start {
                margin-left: 4px; // border-top-left-radius:4px;
                // border-bottom-left-radius:4px;
              }
              &.is-end {
                margin-right: 4px; // border-top-right-radius:4px;
                // border-bottom-right-radius:4px;
              }
              &.is-opacity {
                opacity: 0;
              }
            } // .event-item:hover{
            //   height: auto;
            //   white-space: normal;
            // }
            .more-link {
              cursor: pointer; // text-align: right;
              padding-left: 8px;
              padding-right: 2px;
              color: rgba(0, 0, 0, .38);
              font-size: 14px;
            }
          }
        }
      }
    }
    .more-events {
      position: absolute;
      width: 150px;
      z-index: 2;
      border: 1px solid #eee;
      box-shadow: 0 2px 6px rgba(0, 0, 0, .15);
      .more-header {
        background-color: #eee;
        padding: 5px;
        display: flex;
        align-items: center;
        font-size: 14px;
        .title {
          flex: 1;
        }
        .close {
          margin-right: 2px;
          cursor: pointer;
          font-size: 16px;
        }
      }
      .more-body {
        height: 146px;
        overflow: hidden;
        .body-list {
          height: 144px;
          padding: 5px;
          overflow: auto;
          background-color: #fff;
          .body-item {
            cursor: pointer;
            font-size: 12px;
            background-color: #C7E6FD;
            margin-bottom: 2px;
            color: rgba(0, 0, 0, .87);
            padding: 0 0 0 4px;
            height: 18px;
            line-height: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

a:link,
a:visited {
  color: #444;
  text-decoration: none;
}

td {
  width: 13%; //190px
  //white-space:normal;
}

.shift-btn {
  width: 90%;
  font-size: 16px;
  border: none;
  background-color: white;
  border-radius: 4px;
  margin: 3px;
  margin-top: 10px;
  padding: 3px;
}
//表头
.trborder{
border-right:1px solid rgb(190, 190, 190);
}
//运行未定
.trborder1{
border-right:1px solid rgb(255, 255, 255);
}
//运行预定
.trborder2{
border-right:1px solid rgb(195, 215, 230);
}
//运行中
.trborder3{
border-right:1px solid rgb(140, 150, 210);
}
//运行终了
.trborder4{
border-right:1px solid rgb(220, 220, 220);
}
tr:hover {
  background-color: rgb(110, 110, 110);
}

.contenttr {
  height: 53px;
}

.table>tbody>tr>td {
  padding-top: 13px;
}

.tr-color1 {
  background: rgb(169, 169, 169);
}

.tr-color2 {
  background: rgb(111, 111, 111);
}

.tr-color3 {
  background: rgb(210, 210, 210);
}

.tr-color4 {
  background: rgb(235, 235, 235);
  color: rgb(148, 148, 148);
}

.person-img {
  height: 25px;
  width: 15px;
  margin-top: 5%;
}

.left-img {
  height: 90%;
  width: 20%;
  background: rgb(150, 150, 150);
  margin-right: 5px;
  float: left;
}

.htd {
  padding: 5px;
}

.shift-move-time {
  width: 25%;
}

.shift-id {
  width: 5%;
}

.shift-name {
  width: 62%;
}

.shift-status {
  width: 8%;
}

.move-day {
  border-right: 1px solid #fff;
  text-align: center;
  padding: 0px;
  width: 48%;
}

.move-start {
  border-right: 1px solid #fff;
  text-align: center;
  padding: 0px;
}

.move-arrive {
  text-align: center;
  padding: 0px;
}

.excalmatory-mark {
  height: 20px;
  margin-left: 5px;
}

.member-name{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (max-device-width: 1480px) {
  .common-btn {
    font-size: 14px;
  }
  .left-btn {
    font-size: 16px;
  }
  .contenttr {
    font-size: 14px;
  }
  .shift-btn {
    font-size: 12px;
  }
}
 .member-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/OneDriverScheduleComponent.vue